module.exports = __webpack_public_path__ + "flag_usa.png?f12ac269d6bb87056e499db9f38b4d36";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag_usa.png
// module id = 30
// module chunks = 0